import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';
import { AddUserModel } from 'src/app/models/user/add-user';
import { UserTypeEnum } from 'src/app/models/user/enum/UserTypeEnum';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ManageUsersService } from 'src/app/services/manage-users.service';
import Swal from 'sweetalert2';
export interface DialogData {
  isProfile: boolean;
  record: any;
}
@Component({
  selector: 'app-create-user-model',
  standalone: false,
  templateUrl: './create-user-model.component.html'
})
export class CreateUserModelComponent implements OnInit {
  loading = false
  addUserForm!: UntypedFormGroup
  newUserObject: AddUserModel = new AddUserModel();
  countries: any;
  cities: any[] = [];
  Nationalities: any;
  CountryKey!: string;
  updateUser = false;
  updateSelectedUser: any = [];
  usernameexist = false;
  usernameNumberOnly: boolean = false;
  budge!: string;
  enableCity = false;
  emailnameexist = false;
  visitorCheck = {
    visible: false,
    required: false
  };
  fileToUpload: any = {};
  fileInputValue!: string;
  formErrors: any = [];

  userDetails: any;
  minDate = new Date(1950, 4, 22);
  maxDate = new Date(2002, 3, 22);
  imageSrc!: string;
  countryKey: string = '';
  showErrorMsg = false;
  @ViewChild('fileInput') fileInput!: ElementRef;
  userTypeEnum = UserTypeEnum
  date: any;

  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private manageUserService: ManageUsersService,
    public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<CreateUserModelComponent>,
  ) {

  }

  ngOnInit(): void {
    this.buildForm()
    this.getNationalities();
    if (this.data.record) {
      this.openUpdateForm(this.data.record);
    } else {
      this.getCountries();

    }

  }

  CheckIsVisitor() {
    this.authenticationService.CheckIsVisitor()
      .subscribe(data => {
        this.visitorCheck = data;
        if (this.visitorCheck.required && !this.updateUser) {
          this.addUserForm.controls.isVisitor.setValue(true);
        }
      }, error => {
        console.log(error);
      });
  }

  getCountries() {
    this.manageUserService.getCounties().subscribe(
      data => {
        this.countries = data;
        if (this.data.record) {
          this.addUserForm.controls.countryControl.setValue(parseInt(this.userDetails.countryId));
          this.getCitiesId(this.userDetails.countryId, parseInt(this.userDetails.cityId));
        } else {
          this.addUserForm.controls.countryControl.setValue(2);
          this.getCitiesId(2 , 4);

        }
      },
      error => {
        console.log('Try again!, ' + error);
      });
  }
  getCitiesId(countryId, updateCity: any = undefined) {
    let cId = countryId.value;
    if (updateCity !== undefined) {
      cId = countryId;
    }

    var countryIndex = this.countries.find(e => e.id == cId);
    if (countryIndex && countryIndex.countryKey) {
      this.countryKey = countryIndex.countryKey;
    }

    if (countryId.value !== '') {
      this.enableCity = true;
      this.manageUserService.getCities(cId).subscribe(
        data => {
          this.cities = data as [];
          if (updateCity !== undefined) {
            var check = this.cities.findIndex(e => e.id == updateCity);
            if (check > -1)
              this.addUserForm.controls.cityControl.setValue(updateCity);
          } else {
            this.addUserForm.controls.cityControl.setValue('');
          }
          console.log('data is ', this.cities);
        },
        error => {
          console.log('Try again!, ' + error);
        });
    }
  }
  getNationalities() {
    this.manageUserService.getNationalities().subscribe(
      data => {
        this.Nationalities = data;
        // console.log("data is ", this.Nationalities);
      },
      error => {
        console.log('Try again!, ' + error);
      });
  }


  makeBudge(event) {
    this.budge = this.initName(event.target.value);
  }
  initName(name) {
    var initials = name.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
  }

  // form method
  buildForm() {
    this.addUserForm = this.formBuilder.group({
      emailControl: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}'),
      ]),
      userName: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.pattern('^(?=.*[a-zA-Z])[a-zA-Z0-9._-]+$'),
      ]),
      fullnameControl: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^(?=.*[a-zA-Z])[a-zA-Z0-9 _-]+$')
      ]),
      // employer: new UntypedFormControl('', [
      //   Validators.required
      // ]),
      nameControl: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern('^(?=.*[\u0600-\u06FF])[\u0600-\u06FF0-9 _-]+$')
        // ^(?=.)[0-9\u0600-\u06FF _-]+$
        //
      ]),
      // extentionControl: new FormControl('', [
      //   Validators.required,
      //   Validators.pattern('^((\\+91-?)|0)?[0-9]{2,4}$')
      // ]),
      phoneNumberControl: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^((\\+91-?)|0)?[0-9]{1,12}$')
      ]),
      // NationalitiesControl: new UntypedFormControl('', Validators.required),
      countryControl: new UntypedFormControl('', Validators.required),
      cityControl: new UntypedFormControl('', Validators.required),
      dateOfBirth: new UntypedFormControl('', Validators.required),
      identityNumber: new UntypedFormControl('', Validators.required),
      // jobTitleControl: new UntypedFormControl('', Validators.required),
      gender: new UntypedFormControl('m', Validators.required),
      userTypeEnum: new UntypedFormControl(UserTypeEnum.Ambassador, Validators.required),
      // workLocationControl: new UntypedFormControl('', Validators.required),
      isVisitor: new UntypedFormControl(false),
    });
  }


  userNamemodelChanged(event) {
    console.log('userName is');
    console.log('userName is', event);
    var regexp = new RegExp('^[0-9]*$');
    if (event) {
      this.usernameNumberOnly = regexp.test(event);
    } else {
      this.usernameNumberOnly = false;
    }
    this.authenticationService.checkUsername(event)
      .pipe(first())
      .subscribe(
        data => {
          // console.log('data is!, ' + data);
          if (!this.updateUser) {
            if (data) {
              this.usernameexist = false;
            } else {
              this.usernameexist = true;
              // console.log('usernameexist!, ' + this.usernameexist);
            }
          }

        },
        error => {
          console.log('Try again!, ' + error);
          this.usernameexist = false;
        });
  }

  // emailmodelChanged(event, userId)
  emailmodelChanged(event) {
    // console.log("email is", event);
    let userId;
    if (!this.updateUser) {
      console.log('create');
      userId = '';
    } else {
      userId = this.updateSelectedUser.userID;
    }
    console.log('email is', event, userId);
    this.authenticationService.checkEmail(event, userId)
      .pipe(first())
      .subscribe(
        data => {
          console.log('data is!, ' + data);
          if (data) {
            this.emailnameexist = false;
          } else {
            this.emailnameexist = true;
          }
        },
        error => {
          console.log('Try again!, ' + error);
          this.emailnameexist = false;
        });
  }

  clearDate(event) {
    event.stopPropagation();
    this.date = null;
  }
  saveUser() {
    if (this.addUserForm.valid && !this.emailnameexist && !this.usernameexist) {
      this.loading = true;
      this.executeUserSubs(this.addUserForm.getRawValue());
    }
  }
  openUpdateForm(user) {
    // this.CheckIsVisitor();
    const userId = user.userID;
    this.updateSelectedUser = user;
    this.manageUserService.GetUser(userId).subscribe(
      data => {
        this.updateUser = true; // open edit popup
        this.userDetails = data;
        if (this.updateUser == true) {

          this.getCountries()
          // this.addUserForm.controls.emailControl.disable();
          this.addUserForm.controls.userName.disable();
        } else {
          // this.addUserForm.controls.emailControl.enable();
          this.addUserForm.controls.userName.enable();
        }
        this.addUserForm.controls.emailControl.setValue(data.email);
        this.addUserForm.controls.userName.setValue(data.userName);
        this.addUserForm.controls.fullnameControl.setValue(data.fullName);
        this.addUserForm.controls.nameControl.setValue(data.arabicName);
        if (!data.canEditArabicName) {
          this.addUserForm.controls.nameControl.disable();
        }
        this.addUserForm.controls.userTypeEnum.setValue(data.userTypeEnum);
        this.addUserForm.controls.userTypeEnum.disable();
        // this.addUserForm.controls.NationalitiesControl.setValue(parseInt(data.nationalityId));

        // this.addUserForm.controls.cityControl.setValue(parseInt(data.cityId));
        // this.addUserForm.controls.extentionControl.setValue(data.extention);
        // this.addUserForm.controls.jobTitleControl.setValue(data.jobTitle);
        this.addUserForm.controls.dateOfBirth.setValue(data.birthdate);
        this.addUserForm.controls.identityNumber.setValue(data.identityNumber);
        this.addUserForm.controls.phoneNumberControl.setValue(data.phoneNumber);
        // this.addUserForm.controls.employer.setValue(data.employer);
        // this.addUserForm.controls.workLocationControl.setValue(data.workLocation);
        this.addUserForm.controls.isVisitor.setValue(data.isVisitor);
        this.visitorCheck.visible = true;
        this.visitorCheck.required = data.canEditType;
        this.budge = this.initName(data.fullName);
        if (data.profilePhoto) {
          this.imageSrc = data.profilePhoto;
        }
        // this.addUserForm.controls.gender.setValue('f');
        if (this.addUserForm.controls.gender.value === '') {
          this.addUserForm.controls.gender.setValue('m');
        } else {
          this.addUserForm.controls.gender.setValue(data.gender);
        }
      },
      error => {
        console.log('Try again!, ' + error);
      });
  }
  executeUserSubs(formValues) {
    this.setFormFieldsValues(formValues);
    console.log(this.updateUser, this.newUserObject, this.fileToUpload);
    this.manageUserService.saveUser(this.updateUser, this.newUserObject, this.fileToUpload).subscribe(
      data => {
        this.loading = this.showErrorMsg = false;
        this.openAlert();
      },
      error => {

        if (error && error.detail) {
          Swal.fire({
            title: this.translate.instant('swalMsg.Failed'),
            text: error.detail,
            icon: 'error',
            confirmButtonText: this.translate.instant('swalMsg.ok')
          });
          // this.closeModal();
        }
        // console.error(error);
        this.loading = false;
        this.formErrors = error;
        // console.log(this.formErrors);
        this.showErrorMsg = true;
      },
      () => {

      });
  }
  openAlert() {
    Swal.fire({
      title: this.translate.instant('swalMsg.success'),
      text: '',
      icon: 'success',
      confirmButtonText: this.translate.instant('swalMsg.ok'),
    }).then((result) => {
      this.dialogRef.close(true)
    });
  }
  setFormFieldsValues(addUserFormValue: any) {
    this.newUserObject = {
      email: addUserFormValue.emailControl,
      username: addUserFormValue.userName,
      fullName: addUserFormValue.fullnameControl,
      arabicName: addUserFormValue.nameControl,
      countryKey: this.countryKey,
      // extention: addUserFormValue.extentionControl,
      phoneNumber: addUserFormValue.phoneNumberControl,
      // nationalityId: addUserFormValue.NationalitiesControl,
      countryId: addUserFormValue.countryControl,
      cityId: addUserFormValue.cityControl,
      // jobTitle: addUserFormValue.jobTitleControl,
      profilePhoto: '',
      birthdate: addUserFormValue.dateOfBirth,
      identityNumber: addUserFormValue.identityNumber,
      gender: addUserFormValue.gender,
      userTypeEnum: addUserFormValue.userTypeEnum,
      status: 0,
      joinedDate: '2020-04-22T10:34:50.783Z',
      lastLoginDate: '2020-04-22T10:34:50.783Z',
      password: '12345678910',
      confirmPassword: '12345678910',
      // employer: addUserFormValue.employer,
      // workLocation: addUserFormValue.workLocationControl,
      // isVisitor: addUserFormValue.isVisitor
    };
    if (addUserFormValue.dateOfBirth !== this.updateSelectedUser.birthdate) {
      this.newUserObject.birthdate = this.datePlusDay(addUserFormValue.dateOfBirth);
    }
    if (this.updateUser) {
      this.newUserObject.id = this.updateSelectedUser.userID;
    }
  }

  addFile(event: any) {
    debugger
    // console.log(event);
    let fi = this.fileInput.nativeElement;
    // console.log(this.fileInputValue);
    if (fi.files && fi.files[0]) {
      this.fileToUpload = fi.files[0];
    }
    // Preview File
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
      };
    }
  }

  datePlusDay(date) {
    let newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    return newDate;
  }

  hasError(controlName: string, errorName: string) {
    return this.addUserForm.controls[controlName].hasError(errorName);
  }


}
